import { useSetAtom } from "jotai";
import { useEffect, useState } from "react";
import { useExpenseQuery } from "web_myplann/Api/Finances/useExpenseQuery";
import { useIncomeQuery } from "web_myplann/Api/Finances/useIncomeQuery";
import {
	mapExpenseToFinanceState,
	mapIncomeToFinanceState,
} from "web_myplann/Finances/Helpers/mapFinanceState";
import { financeState } from "web_myplann/Finances/State/FinanceAtom";

export const useSyncFinanceState = () => {
	const { data: income, isSuccess: isIncomeSuccess } = useIncomeQuery();
	const { data: expenses, isSuccess: isExpensesSuccess } = useExpenseQuery();

	const setFinance = useSetAtom(financeState);
	const [isHydrated, setIsHydrated] = useState(false);

	const isLoaded = isIncomeSuccess && isExpensesSuccess;

	useEffect(() => {
		if (!isLoaded || isHydrated) {
			return;
		}

		setFinance({
			income: income?.data?.map(mapIncomeToFinanceState) ?? [],
			expenses: expenses?.data?.map(mapExpenseToFinanceState) ?? [],
		});
		setIsHydrated(true);
	}, [isLoaded, isHydrated, income?.data, expenses?.data, setFinance]);

	return { isHydrated };
};
